module.exports = __webpack_public_path__ + "media/images/coffee-bg-c0041950c8aabdb6248ef186cc2e10d2.jpg";